import { render } from "./term-conditions.vue?vue&type=template&id=d191c28e"
import script from "./term-conditions.vue?vue&type=script&lang=js"
export * from "./term-conditions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__